import { render, staticRenderFns } from "./rich-text.global.vue?vue&type=template&id=65e96aa9&functional=true&"
import script from "./rich-text.global.vue?vue&type=script&lang=js&"
export * from "./rich-text.global.vue?vue&type=script&lang=js&"
import style0 from "./rich-text.global.vue?vue&type=style&index=0&id=65e96aa9&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports